import axios from 'axios'

let baseURL = process.env.REACT_APP_BACKEND_URL + '/api/';

if (window.location.hostname.includes('ngrok-free.app')) {
    baseURL = 'https://01f39ee69d9d.ngrok-free.app/avto-obuchenie-2024/public/api/'
}

const Api = axios.create({ baseURL })

Api.interceptors.request.use((config) => {
    const token = localStorage.getItem('auth') ? JSON.parse(localStorage.getItem('auth')).user.token : ''

    config.params = config.params || {}

    config.headers['X-Path'] = window.location.pathname + window.location.search

    config.headers['Authorization'] = `Bearer ${token}`

    config.headers['ngrok-skip-browser-warning'] = 'test';

    return config
})

export default Api